import React from "react";
import Button from "../Inputs/Button";
import { useNavigate } from "react-router-dom";

const Insight = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-[#FFF] flex-col sm:flex-row gap-6 flex-wrap pt-10 pb-14 flex ">
      <div className="flex-1 max-w-[90%] mx-auto sm:pl-[8%] flex flex-col justify-center">
        <h3 className="font-[500] max-w-[503px] mb-[20px] sm:mb-[80px] text-[28px] sm:text-[44px] text-[#000]  sm:leading-[48px] ">
          Prominent organization we’ve worked with over the years
        </h3>

        <div className="hidden sm:block">
          <Button
            classes={"!bg-[#0E318A] !w-[193px]"}
            onClick={() => {
              navigate("/about-us");
            }}
            title={"Learn More"}
          />
          <div className="w-full border-t mt-[50px] max-w-[429px] border-t-[rgba(0,0,0,0.2)]">
            <h3 className="font-[500] max-w-[503px] mt-[16px] text-[24.12px] sm:text-[44px] text-[#000]  sm:leading-[48px] ">
              12+
            </h3>
            <h3 className="font-[500]  text-[12px] sm:text-[14px] mt-2 text-[#000]  ">
              Years of Integrity, Quality, Innovation & Commitment
            </h3>
          </div>
        </div>
      </div>

      <div className="flex-1 items-center  justify-center  flex">
        <div className="min-w-[90%] sm:min-w-[495.26px] bg-[#0E8A28] p-8 lg:p-10 2xl:p-12 !pb-0">
          <div className="flex gap-2 border-b-[rgba(0,0,0,0.1)] border-b-[0.8px] py-3 px-4 w-full bg-[#FFF]">
            <div className="bg-[rgba(0,0,0,0.1)] w-[5px] h-[5px] rounded-full"></div>
            <div className="bg-[rgba(0,0,0,0.1)] w-[5px] h-[5px] rounded-full"></div>
            <div className="bg-[rgba(0,0,0,0.1)] w-[5px] h-[5px] rounded-full"></div>
          </div>
          <div className="w-full bg-[#FFF] px-4 sm:px-10">
            <div className="justify-between w-full border-b-[rgba(0,0,0,0.3)] gap-3 border-b-[1px]  flex items-center py-12">
              <h4 className="font-[500] w-full max-w-[180px] text-[14px] sm:text-[19.2px] text-[#000] sm:leading-[25px] ">
                Federal Immigration Service Hospital
              </h4>
              <h4 className="font-[600]  text-[18px] sm:text-[24.56px] text-[#000] sm:leading-[39.29px] ">
                2011
              </h4>
            </div>
            <div className="justify-between w-full border-b-[rgba(0,0,0,0.3)] gap-3 border-b-[1px]  flex items-center py-12">
              <h4 className="font-[500] w-full max-w-[180px] text-[14px] sm:text-[19.2px] text-[#000] sm:leading-[25px] ">
                University of Maiduguri
              </h4>
              <h4 className="font-[600]  text-[18px] sm:text-[24.56px] text-[#000] sm:leading-[39.29px] ">
                2018
              </h4>
            </div>
            <div className="justify-between w-full flex gap-3 items-center py-12">
              <h4 className="font-[500] w-full max-w-[180px] text-[14px] sm:text-[19.2px] text-[#000] sm:leading-[25px] ">
                IMO State Teaching Hospital
              </h4>
              <h4 className="font-[600]  text-[18px] sm:text-[24.56px] text-[#000] sm:leading-[39.29px] ">
                2019
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 w-full mt-[20px] flex sm:hidden max-w-[90%] mx-auto sm:pl-[8%]  flex-col justify-center">
        <div className="">
          <Button
            classes={"!bg-[#0E318A] !w-[193px]"}
            onClick={() => {
              navigate("/about-us");
            }}
            title={"Learn More"}
          />
          <div className="w-full border-t mt-[50px] max-w-[429px] border-t-[rgba(0,0,0,0.2)]">
            <h3 className="font-[500] max-w-[503px] mt-[16px] text-[24.12px] sm:text-[44px] text-[#000]  sm:leading-[48px] ">
              12+
            </h3>
            <h3 className="font-[500]  text-[12px] sm:text-[14px] mt-2 text-[#000]  ">
              Years of Integrity, Quality, Innovation & Commitment
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insight;
